module.exports = __webpack_public_path__ + "img/Emirates.a6ec7303.jpg";